enum PaymentMethod {
  GatekeeperTerminal = 'gatekeeperTerminal',
  GatekeeperExternalBilling = 'gatekeeperExternalBilling',
  ExternalBilling = 'externalBilling',
}

export default PaymentMethod;
